import { render, staticRenderFns } from "./salesComponent.vue?vue&type=template&id=f78e97bc"
import script from "./salesComponent.vue?vue&type=script&lang=js"
export * from "./salesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports